import { useCallback, useState } from 'react';
import { DormitoryHttp } from '@/services';
import { parseError } from '@/utils';

export default function useDormitoryQualify(preReg: boolean = false, defaultLoading: boolean = false) {
  const [qualify, setQualify] = useState<DormitoryQualifyResponse>();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(defaultLoading);

  const fetchQualify = useCallback(async () => {
    setLoading(true);
    try {
      const response = await DormitoryHttp.getDormitoryQualify({ preReg });
      setQualify(response.data?.payload);
    }
    catch (e) {
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, []);

  return { qualify, fetchQualify, error, loading };
}
